<template>
    <div class="product-description">
        <el-tabs v-model="activeName" type="border-card">
            <el-tab-pane :label="$lange == 'en' ? 'Product Description' : '产品详情'" name="description">
                <ProductComponent></ProductComponent>
            </el-tab-pane>
            <el-tab-pane :label="$lange == 'en' ? 'Equipment List' : '设备清单'" name="machine">
                <ProductMachine :isProduct="true" :jobId="productData.jobId"></ProductMachine>
<!--                <div class="machine">-->
<!--                    <div class="search-group">-->
<!--                        <div class="input-box">-->
<!--                            <el-input size="mini" v-model="machineTableParams.machineModel" placeholder="请输入机器名称"></el-input>-->
<!--                        </div>-->
<!--                        <div class="input-box">-->
<!--                            <el-input size="mini" v-model="machineTableParams.sapCode" placeholder="请输入SAP Code"></el-input>-->
<!--                        </div>-->
<!--                        <div class="input-box">-->
<!--                            <el-input size="mini" v-model="machineTableParams.fiCom" placeholder="请输入FI Com"></el-input>-->
<!--                        </div>-->
<!--                        <div class="input-box">-->
<!--                            <el-input size="mini" v-model="machineTableParams.fasSn" placeholder="请输入FAS SN"></el-input>-->
<!--                        </div>-->
<!--&lt;!&ndash;                        <el-button type="primary" size="mini">关联机器</el-button>&ndash;&gt;-->
<!--                    </div>-->
<!--                    <div class="table-box">-->
<!--                        <cc-table :config="machineTableConfig"-->
<!--                                  :params="machineTableParams"-->
<!--                                  :load-data="machineTableParams.jobId.length > 0"-->
<!--                        ></cc-table>-->
<!--                    </div>-->
<!--                </div>-->
            </el-tab-pane>
            <!-- <el-tab-pane :label="$lange == 'en' ? 'Financial data' : '费用提报'" name="cost">
                <div class="cost">
                    <div class="title">
                        <el-select v-model="costTableParams.type" size="mini" :placeholder="$lange == 'en' ? 'Please select type' : 'type'" clearable >
                            <el-option :label="$lange == 'en' ? 'All' : '全部'" value=""></el-option>
                            <el-option :label="$lange == 'en' ? 'Install' : '安装'" :value="0"></el-option>
                            <el-option :label="$lange == 'en' ? 'During the warranty period' : '保内'" :value="1"></el-option>
                            <el-option :label="$lange == 'en' ? 'Outside the warranty period' : '保外'" :value="2"></el-option>
                        </el-select>
                        <el-date-picker
                                v-model="costTableParams.declarationTime"
                                value-format="yyyy-MM"
                                type="month"
                                size="mini"
                                style="margin: 0 20px"
                                :placeholder="$lange == 'en' ? 'Please select month' : '选择月'">
                        </el-date-picker>
                        <el-button type="primary" size="mini" @click="doSearch">{{$lange == "en" ? "Search" : "搜索"}}</el-button>
                        <el-button size="mini" type="primary" @click="addCost = true">{{$lange == 'en' ? 'Add' : '费用提报'}}</el-button>
                    </div>
                    <div class="table-box">
                        <cc-table
                                :config="costTableConfig"
                                :params="costTableParams2"
                                :loadData="costTableParams.productId.length > 0"
                                :refesh-params="costTableRefer"
                                :show-summary="true"
                                :summaryFun="getSummaries"
                        >
                        </cc-table>

                    </div>
                </div>
            </el-tab-pane> -->
        </el-tabs>
        <el-dialog
                :title="$lange == 'en' ? 'Add Machine' : '添加配件'"
                :visible.sync="addCost"
                width="40%"
                class="partsForm"
                @close="cancelForm"
        >
            <el-form :model="form" size="mini" :label-width="$lange=='en' ? '160px' : '130px'"
                     style="max-width: 400px;"
                     v-loading="formLoading">

                <el-form-item required="true" label="Job ID">
                    <span>{{productData.jobId }}</span>
                </el-form-item>

                <el-form-item required="true" :label="$lange == 'en' ? 'Months' : '提报月度'">
                    <span v-if="editCostId.length > 1">{{form.declarationTime}}</span>
                    <el-date-picker
                            v-else
                            v-model="form.declarationTime"
                            value-format="yyyy-MM"
                            type="month"
                            placeholder="选择月">
                    </el-date-picker>
                </el-form-item>

                <el-form-item required="true" :label="$lange == 'en' ? 'Type' : '类型'">
<!--                    <cc-constant-selector style="display:inline-block;"-->
<!--                                          type="select"-->
<!--                                          valType="String"-->
<!--                                          placeholder="请选择产品类型"-->
<!--                                          v-model="form.type"-->
<!--                                          code="productStatus"-->
<!--                                          api="admin/dict/pageTree"/>-->
                    <el-select v-model="form.type" :placeholder="$lange == 'en' ? 'Please Select' : '请选择'">
                        <el-option
                                v-for="item in productStatus"
                                :key="item.type"
                                :label="item.text"
                                :value="item.type">
                            {{item.text}}
                        </el-option>
                    </el-select>
                </el-form-item>

<!--                <el-form-item required=true :label="$lange=='en' ? 'Spare Part Cost(RMB)' : '配件成本 (元)'">-->
<!--                    <span>{{form.partsFee}}</span>-->
<!--                </el-form-item>-->

                <el-form-item required="true" :label="$lange=='en' ? 'Labor Cost(RMB)' : '人工成本 (元)'">
                    <el-input v-model.number="form.serviceFee" row="4" :placeholder="$lange == 'en' ? 'Please Input' : '请输入价格'"></el-input>
                </el-form-item>
                <el-form-item required="true" :label="$lange=='en' ? 'Travel expenses(RMB)' : '差旅成本 (元)'">
                    <el-input v-model.number="form.travelFee"  row="4" :placeholder="$lange == 'en' ? 'Please Input' : '请输入价格'"></el-input>
                </el-form-item>
                <el-form-item required="true" :label="$lange=='en' ? 'Other Cost(RMB)' : '其他成本 (元)'">
                    <el-input v-model.number="form.otherFee" :placeholder="$lange == 'en' ? 'Please Input' : '请输入单价'"></el-input>
                </el-form-item>

                <el-form-item >
                    <el-button @click="addCost = false">{{$lange=='en' ? 'Cancel' : '取消'}}</el-button>
                    <el-button type="primary" @click="submitForm">{{$lange=='en' ? 'Submit' : '提交'}}</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <div class="back-btn" >
            <el-button type="primary" size="mini" @click="backBtn('/workbench')">返回首页</el-button>
            <el-button type="warning" size="mini" @click="backBtn('/admin/product/list')">返回列表</el-button>
        </div>
    </div>
</template>

<script>
    import ProductComponent from "./components/ProductComponent";
    import ProductMachine from "./ProductMachine";
    import moment from "moment";

    export default {
        name: "ProductDescription",
        components: {
            ProductComponent,
            ProductMachine
        },
        data(){
            return {
                activeName: "description",
                costTableConfig: {
                    api: "admin/fsb/product/fee/query",
                    showPager: true,
                    showIndex: true,
                    columns: [
                        {
                            prop: "declarationTime",
                            lable: "提报时间",
                            render: row => {
                                return moment(row.declarationTime).format("YYYY-MM");
                            }
                        },
                        {
                            prop: "type",
                            lable: "类型",
                            type: "tag",
                            options: [
                                {tagType: "info", text: "安装"},
                                {tagType: "success", text: "保内"},
                                {tagType: "warning", text: "保外"},
                            ]
                        },
                        {
                            prop: "partsFee",
                            lable: "配件成本",
                            render: row => {
                                return row.partsFee / 100;
                            }
                        },
                        {
                            prop: "serviceFee",
                            lable: "服务成本",
                            render: row => {
                                return row.serviceFee / 100;
                            }
                        },
                        {
                            prop: "travelFee",
                            lable: "差旅成本",
                            render: row => {
                                return row.travelFee / 100;
                            }
                        },
                        {
                            prop: "otherFee",
                            lable: "其他成本",
                            render: row => {
                                return row.otherFee / 100;
                            }
                        },
                        {
                            prop: "createTime",
                            lable: "创建时间",
                            render: row => {
                                let res = ""
                                if(!row.createTime){
                                    res = "---"
                                } else {
                                    res = moment(row.createTime).format("YYYY-MM-DD")
                                }
                                return res;
                            }
                        },
                    ],
                    buttons: [
                        {
                            name: "编辑",
                            check: row => {
                                let res = true;
                                if(row.partsFee > 0){
                                    res = false;
                                }
                                return res;
                            },
                            click: row => {
                                let formData = JSON.stringify(row);
                                let feeArr = ["serviceFee", "travelFee", "otherFee", "partsFee"];
                                formData = JSON.parse(formData);
                                for(let i in this.form){
                                    if(feeArr.indexOf(i)> -1){
                                        formData[i] = formData[i] / 100;
                                    }
                                    if(formData[i]){
                                        this.form[i] = formData[i].toString();
                                    }

                                }

                                this.editCostId = row.id;
                                this.addCost = true;
                            }
                        },
                        {
                            name: "删除",
                            check: row => {
                                let res = true;
                                if(row.partsFee > 0){
                                    res = false;
                                }
                                return res;
                            },
                            click: row => {
                                this.$confirm('此操作会删除该条数据?', '提示', {
                                    confirmButtonText: '确定',
                                    cancelButtonText: '取消',
                                    type: 'warning'
                                }).then(() => {
                                    let data = {
                                        id: row.id
                                    }
                                    this.ccRequest.do("admin/fsb/product/fee/delete", data, "GET").then(res => {
                                        this.$message({
                                            type: 'success',
                                            message: '删除成功'
                                        });
                                        this.costTableRefer = new Date().getTime();
                                    })
                                }).catch(() => {
                                    // this.$message({
                                    //     type: 'info',
                                    //     message: '已取消'
                                    // });
                                });
                            }
                        },
                    ]
                },
                costTableParams: {
                    productId: "",
                    feeType: 0,
                    declarationTime: '',
                    type: '',
                },
                costTableParams2:{
                    productId: "",
                    feeType: 0,
                    declarationTime: '',
                    type: '',
                },
                costTableRefer: -1,
                addCost: false,
                form: {
                    declarationTime: "",
                    type: "",
                    serviceFee: 0,
                    travelFee: 0,
                    otherFee: 0,
                    partsFee: 0,
                },
                editCostId: false,
                formLoading: false,
                productStatus: [
                    { type: 0, text: "安装", },
                    { type: 1, text: "保内", },
                    { type: 2, text: "保外", },
                ],
                productData: {},
            }
        },
        methods: {
            doSearch() {
                this.costTableParams2={...this.costTableParams}
            },
            getSummaries(param) {
                const { columns, data } = param;
                const sums = [];

                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = "合计";
                        return;
                    }
                    sums[index] = " ";
                    // console.log("index", index, column.property);

                    if ( index == 3 || index == 4 || index == 5 || index == 6) {
                        const values = data.map(item => Number(item[column.property]));

                        if (!values.every(value => isNaN(value))) {
                            sums[index] = values.reduce((prev, curr, ind) => {
                                const value = Number(curr);
                                if (!isNaN(value) ) {
                                    if(index == 3 || index == 4 || index == 5 || index == 6){
                                        return this.accAdd(prev,curr);
                                    }else{
                                        return prev + curr;
                                    }
                                } else {
                                    return prev;
                                }
                                //总金额

                                // console.log(prev);
                                // console.log(prev + curr);
                            }, 0);
                            if(index == 3 || index == 4 || index == 5 || index == 6){
                                sums[index] = this.formatPrice(sums[index])
                            }
                        }
                    }
                });

                return sums;
            },
            accAdd(arg1, arg2) {
                var r1, r2, m;
                try {
                    r1 = arg1.toString().split(".")[1].length;
                } catch (e) {
                    r1 = 0;
                }
                try {
                    r2 = arg2.toString().split(".")[1].length;
                } catch (e) {
                    r2 = 0;
                }
                m = Math.pow(10, Math.max(r1, r2));
                return (arg1 * m + arg2 * m) / m;
            },
            cancelForm(){
                for(let i in this.form){
                    this.form[i] = ""
                }
                this.addCost = false;
                this.editCostId = false;
            },
            backBtn(path) {
                this.$router.push({
                    path: path
                });
            },
            submitForm() {
                let obj = JSON.stringify(this.form);
                let data = JSON.parse(obj);
                let feeArr = ["serviceFee", "travelFee", "otherFee", "partsFee"];
                for(let i in feeArr){
                    data[feeArr[i]] *= 100;
                }
                data.productId = this.costTableParams.productId;
                this.editCostId ? data.id = this.editCostId : false;
                this.ccRequest.do('admin/fsb/product/fee/save', data, "POSTJSON").then(res => {
                    this.$message({
                        type: "success",
                        message: "操作成功"
                    })
                    this.addCost = false;
                    this.editCostId  = false;
                    this.costTableRefer = new Date().getTime();
                })
            },
            getProduct() {
                let data = {
                    id: this.costTableParams.productId
                }
                this.ccRequest.do("admin/fsb/product/get", data, "GET").then(res => {
                    this.productData = res;
                })
            },
            checkLanguage(){
                if(this.$lange == 'en'){
                    this.costTableConfig = {
                        api: "admin/fsb/product/fee/query",
                        showPager: true,
                        showIndex: true,
                        columns: [
                            {
                                prop: "declarationTime",
                                lable: "Reporting Time",
                                render: row => {
                                    return moment(row.declarationTime).format("YYYY-MM");
                                }
                            },
                            {
                                prop: "type",
                                lable: "Type",
                                type: "constant",
                                constantConfig: {
                                    code: "productStatus",
                                    api: "admin/dict/pageTree",
                                    opts: { 0: "info", 1: "warning",  2: "success", 3: "danger" }
                                },
                            },

                            {
                                prop: "partsFee",
                                lable: "Spare Part Cost",
                                render: row => {
                                    return row.partsFee / 100;
                                }
                            },
                            {
                                prop: "serviceFee",
                                lable: "Labor Cost",
                                render: row => {
                                    return row.serviceFee / 100;
                                }
                            },
                            {
                                prop: "travelFee",
                                lable: "Travel expenses",
                                render: row => {
                                    return row.travelFee / 100;
                                }
                            },
                            {
                                prop: "otherFee",
                                lable: "Other Cost",
                                render: row => {
                                    return row.otherFee / 100;
                                }
                            },
                            {
                                prop: "updateTime",
                                lable: "Last Update",
                                render: row => {
                                    let res = ""
                                    if(!row.updateTime){
                                        res = "---"
                                    } else {
                                        res = moment(row.updateTime).format("YYYY-MM-DD")
                                    }
                                    return res;
                                }
                            },
                        ],
                        buttonsLabel: "Operation",
                        buttons: [
                            {
                                name: "Edit",
                                check: row => {
                                    let res = true;
                                    if(row.partsFee > 0){
                                        res = false;
                                    }
                                    return res;
                                },
                                click: row => {
                                    for(let i in this.form){
                                        if(row[i]){
                                            this.form[i] = row[i].toString();
                                        }
                                    }
                                    this.editCostId = row.id;
                                    this.addCost = true;
                                }
                            },
                            {
                                name: "Delete",
                                check: row => {
                                    let res = true;
                                    if(row.partsFee > 0){
                                        res = false;
                                    }
                                    return res;
                                },
                                click: row => {
                                    this.$confirm('此操作会删除该条数据?', '提示', {
                                        confirmButtonText: '确定',
                                        cancelButtonText: '取消',
                                        type: 'warning'
                                    }).then(() => {
                                        let data = {
                                            id: row.id
                                        }
                                        this.ccRequest.do("admin/fsb/product/fee/delete", data, "GET").then(res => {
                                            this.$message({
                                                type: 'success',
                                                message: '删除成功'
                                            });
                                            this.costTableRefer = new Date().getTime();
                                        })
                                    }).catch(() => {
                                        // this.$message({
                                        //     type: 'info',
                                        //     message: '已取消'
                                        // });
                                    });
                                }
                            },
                        ]
                    }
                }

            }

        },
        mounted() {
            this.checkLanguage()
            // this.costTableParams.productId = "1163808671236378626";
            if(!this.$route.query.productId){
                this.$router.go(-1)
                return false;
            }
            this.costTableParams.productId = this.$route.query.productId;
            this.costTableParams2.productId = this.$route.query.productId;
            this.getProduct();

        }
    }
</script>
<style>
    .el-tabs__content{
        padding: 0 !important;
    }
</style>
<style scoped lang="scss">
    .el-tabs--border-card{
        background: transparent;
        box-shadow: none;
        border: none;
    }
    .machine{
        background: #fff;
        padding: 20px;
        .input-box{
            margin-right: 20px;
        }
        .search-group{
            display: flex;
            margin-bottom: 20px;
        }
    }
    .cost{
        background: #fff;
        padding: 20px;
        .title{
            margin-bottom: 20px;
        }
    }
</style>
